<template>
  <main class="main-content" id="topDom">
    <!-- 轮播 -->
    <section class="section --main-slider">
      <!-- 中文 -->
      <div class="swiper mySwiper" v-if="$i18n.locale == 'zh'">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-container block-main-slider__slide" style="cursor: pointer;"
            :style="{ height: (isMobile() ? (windowHeight - 110) + 'px !important' : 'auto') }"
            v-for="(item, index) in cnSwiperData" :key="index" @click="$router.push(item.path)">
            <div class="commonBg"
              :class="index == 0 ? 'block-main-slider__slide-bg' : index == 1 ? 'block-main-slider__slide-bgTwo' : 'block-main-slider__slide-bgThree'">
              <!-- height: (isMobile() ? (windowHeight - 110) + 'px !important' : '') -->
              <img class="swiper-lazy img-responsive pc"
                :class="index == 0 ? 'specialClass1' : index == 2 ? 'specialClass3' : ''"
                :style="{ width: (isMobile() ? windowWidth + 'px !important' : ''), height: 'auto' }"
                :src="isMobile() ? item.imgP : item.imgS" alt="轮播图">
            </div>
            <!--  -->
            <div class="container-fluid --swiper block-main-slider__h100" v-if="isMobile()">
              <div class="row block-main-slider__h100">
                <div class="col-12 col-md-8 block-main-slider__h100 --mobile-auto order-2 order-md-1 mt-auto mt-md-0">
                  <div class="block-main-slider__slide-text" v-if="!isMobile()">
                    <span class="banner__type"> {{ item.about }}</span>
                    <h3 class="banner__title">{{ item.title }}</h3>
                    <h4 class="banner__subtitle" v-html="item.content"></h4>
                    <div class="row banner__button-wrapper">
                      <div class="col-12 col-md-5 pr-2 pr-md-5" :class="item.showStyle ? 'swiper-btn' : ''">
                        <div class="btn --primary --banner mt-2 mt-md-4 d-inline-flex d-md-flex w-auto w-md-100"
                          @click="$router.push(item.path)">{{ $t('i18n.readBtn') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banner-btn">
          <div class="scrollbar-caption pc text1">{{ $t('i18n.companyIntroduction') }}</div>
          <div class="scrollbar-caption pc text2">{{ $t('i18n.productServices') }}</div>
          <div class="scrollbar-caption pc text3">{{ $t('i18n.description') }}</div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-scrollbar" v-show="!isMobile()">
          <div class="swiper-scrollbar-drag" :style="dragBarClass"></div>
        </div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button-next swiper-button-white"></div>
      </div>

      <div class="swiper mySwiper" v-else>
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-container block-main-slider__slide" style="cursor: pointer;"
            :style="{ height: (isMobile() ? (windowHeight - 110) + 'px !important' : 'auto') }"
            v-for="(item, index) in enSwiperData" :key="index" @click="$router.push(item.path)">
            <div class="commonBg"
              :class="index == 0 ? 'block-main-slider__slide-bg' : index == 1 ? 'block-main-slider__slide-bgTwo' : 'block-main-slider__slide-bgThree'">
              <!-- height: (isMobile() ? (windowHeight - 110) + 'px !important' : '') -->
              <img class="swiper-lazy img-responsive pc"
                :class="index == 0 ? 'specialClass1' : index == 2 ? 'specialClass3' : ''"
                :style="{ width: (isMobile() ? windowWidth + 'px !important' : ''), height: 'auto' }"
                :src="isMobile() ? item.imgP : item.imgS" alt="轮播图">
            </div>
            <!--  -->
            <div class="container-fluid --swiper block-main-slider__h100" v-if="isMobile()">
              <div class="row block-main-slider__h100">
                <div class="col-12 col-md-8 block-main-slider__h100 --mobile-auto order-2 order-md-1 mt-auto mt-md-0">
                  <div class="block-main-slider__slide-text" v-if="!isMobile()">
                    <span class="banner__type"> {{ item.about }}</span>
                    <h3 class="banner__title">{{ item.title }}</h3>
                    <h4 class="banner__subtitle" v-html="item.content"></h4>
                    <div class="row banner__button-wrapper">
                      <div class="col-12 col-md-5 pr-2 pr-md-5" :class="item.showStyle ? 'swiper-btn' : ''">
                        <div class="btn --primary --banner mt-2 mt-md-4 d-inline-flex d-md-flex w-auto w-md-100"
                          @click="$router.push(item.path)">{{ $t('i18n.readBtn') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banner-btn">
          <div class="scrollbar-caption pc text1">{{ $t('i18n.companyIntroduction') }}</div>
          <div class="scrollbar-caption pc text2">{{ $t('i18n.productServices') }}</div>
          <div class="scrollbar-caption pc text3">{{ $t('i18n.description') }}</div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-scrollbar" v-show="!isMobile()">
          <div class="swiper-scrollbar-drag" :style="dragBarClass"></div>
        </div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button-next swiper-button-white"></div>
      </div>
    </section>
    <!-- 查询 -->
    <section class="section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="scroll-down"></div>
            <h2 class="label-text text-left text-md-center mb-3">{{ $t('i18n.homeSearchTextOne') }}</h2>
            <h3 class="label-text2 text-left text-md-center mb-3">{{ $t('i18n.homeSearchTextTwo') }}</h3>
            <div id="productFilter" class="product-filter --radio">
              <div class="product-filter__search">
                <input type="text" v-model="form.keyword" class="product-filter__search-input"
                  :placeholder="$t('i18n.homeSearchTextPlaceholder')">
                <button class="product-filter__search-icon" @click="search"></button>
              </div>
              <!-- <div class="product-filter__filter-btn" @click="search">{{ $t('i18n.search') }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 新闻 -->
    <section class="section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="pr-0 pr-md-2">
              <div class="block-news">
                <div class="block-news__header">
                  <h3 class="label --news">{{ $t("i18n.newsVal") }}</h3>
                  <router-link to="/News" class="text-link --small ml-auto d-none d-md-flex">
                    {{ $t("i18n.companyConsultation") }}
                  </router-link>
                </div>
                <div class="block-news__content">
                  <router-link :to="{ name: 'NewsDetail', params: { form: item } }" class="block-news__article"
                    v-for="(item, index) of news" :key="index">
                    <span>{{ item.create_time.substring(0, 10) }}</span>
                    <h4>{{ item.title }}</h4>
                    <p v-html="item.intro"></p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-6 mt-md-0">
            <div class="pl-0 pl-md-2">
              <div class="block-downloads">
                <h3 class="label --downloads">{{ $t("i18n.downloadFile") }}</h3>
                <p class="block-download__text">{{ $t("i18n.downloadText") }}</p>
                <h4 style="font-size: 20px;" class="label mt-3 mt-md-4 mb-2 mb-md-3 d-none d-md-block">{{
                  $t("i18n.downloadTextTwo") }}</h4>
                <ul class="ul-links mt-3 mt-md-0 d-none d-md-block">
                  <li class="ul-link">
                    <router-link to="/VacuumValveMain" class="text-link --big">{{ $t("i18n.vacuumValve") }}</router-link>
                  </li>
                  <li class="ul-link">
                    <router-link to="/Presys" class="text-link --big">{{ $t("i18n.presys") }}</router-link>
                  </li>
                  <!-- <li class="ul-link">
                    <router-link to="/throttleValve" class="text-link --big">{{ $t("i18n.genius") }}</router-link>
                  </li> -->
                  <li class="ul-link">
                    <router-link to="/mne" class="text-link --big">{{ $t("i18n.otherProducts") }}</router-link>
                  </li>
                </ul>
                <router-link to="/download" class="btn --secondary --ongray mt-4">{{ $t("i18n.downloadCenter")
                }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心产品 -->
    <section class="section" style="background: #F8F8F8; ">
      <div class="container-fluid --swiper">
        <div class="row mt-6 mt-md-12">
          <div class="col-12">
            <div class="block-case-studies">
              <div class="block-case-studies__header">
                <h3 class="label --case-studies">{{ $t("i18n.CoreProducts") }}</h3>
                <router-link to="/VacuumValveMain" class="text-link --small ml-auto d-none d-md-flex">{{
                  $t("i18n.moreProducts") }}</router-link>
              </div>
            </div>
          </div>
          <div class="col-12">

            <div class="outSwiperBox">
              <div id="swiper-pro">
                <div class="swiper-container pro-swiper inSwiperBox">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in $t('i18n.proList')" :key="index"
                      @click="toPage(item)">
                      <div class="swiper-content swiper-content-select">
                        <div class="swiper-pro-bottom">
                          <div class="swiper-pro-img">
                            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
                          </div>
                          <div class="swiper-pro-text">
                            {{ item.about }}
                          </div>
                          <a class="swiper-pro-btn">&nbsp;&nbsp;{{ $t("i18n.learnMore") }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 如果需要导航按钮 -->
                  <!--                  <div class="swiper-button-prev swiper-button-white"></div>-->
                  <!--                  <div class="swiper-button-next swiper-button-white"></div>-->
                  <!-- <div class="swiper-button-prev pro-swiper-prev --pro"></div>
                  <div class="swiper-button-next pro-swiper-next --pro"></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <!-- 佳晟真空 -->
    <section class="section block-about">
      <div class="container-fluid ">
        <div class="row">
          <div class="col-12">
            <h3 class="label --b-company">{{ $t("i18n.company") }} </h3>
          </div>
          <div class="col-12 col-md-8">
            <p class="block-about__text">{{ $t("i18n.companyText") }} </p>
          </div>
          <div class="col-12 col-md-3 ml-auto">
            <ul class="ul-links mt-3 mt-md-0">
              <li class="ul-link">
                <router-link to="/about" class="text-link --big">{{ $t("i18n.about") }}</router-link>
              </li>
              <li class="ul-link">
                <router-link to="/CareerOpportunities" class="text-link --big">{{ $t("i18n.aboutText") }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Swiper from "swiper";
import '../assets/css/main.css'
import { getHome, homeSearch } from "../api/api.js";
export default {
  name: "Home",
  components: {
  },
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      windowWidth: document.documentElement.clientWidth,
      list: [
        {
          name: "vacuumValve",
          path: "VacuumValveMain",
          isLast: true,
          showChild: false,
        },
        {
          name: "MGVAGV",
          path: "VacuumValve1",
          isLast: true,
          showChild: false,
          pathImg: require('../assets/imgs/MGVAGV.png'),
          img: require('../assets/imgs/MGVAGVimg.png'),
          technicalImg: require('../assets/imgs/MGVAGVTechnical.png'),
          downloadImg: require('../assets/imgs/MGVAGVDownloadImg.png'),
          propertiesName: "MGVAGVpro",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "butterflyValve",
          path: "VacuumValve2",
          isLast: true,
          showChild: false,
          pathImg: require('../assets/imgs/butterfly.png'),
          img: require('../assets/imgs/butterflyImg.png'),
          technicalImg: require('../assets/imgs/butterflyTechnical.png'),
          downloadImg: require('../assets/imgs/butterfluDownloadImg.png'),
          propertiesName: "butterflyPro",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "highVacuumDirectValve",
          path: "VacuumValve3",
          isLast: true,
          pathImg: require('../assets/imgs/corner.png'),
          img: require('../assets/imgs/corenrImgTwo.png'),
          technicalImg: require('../assets/imgs/corenrTechnicalOne.png'),
          downloadImg: require('../assets/imgs/corenrDownloadOne.png'),
          propertiesName: "highVacuumDirectValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "UHV",
          path: "VacuumValve4",
          isLast: true,
          pathImg: require('../assets/imgs/corner.png'),
          img: require('../assets/imgs/corenrImg.png'),
          technicalImg: require('../assets/imgs/corenrTechnicalTwo.png'),
          downloadImg: require('../assets/imgs/corenrDownloadTwo.png'),
          propertiesName: "UHV",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "rectangularValve",
          path: "VacuumValve5",
          showChild: false,
          isLast: true,

          pathImg: require('../assets/imgs/rectangularValve.png'),
          img: require('../assets/imgs/rectangularValveImg.png'),
          technicalImg: require('../assets/imgs/rectangularValveTechnical.png'),
          downloadImg: require('../assets/imgs/rectangularValveDownload.png'),
          propertiesName: "rectangularValve",
          showFlg: false,
          type: "PDF",
          size: "4 MB"
        }, {
          name: "highVacuumGateValve",
          path: "VacuumValve6",
          isLast: true,

          pathImg: require('../assets/imgs/highVacuum.png'),
          img: require('../assets/imgs/highVacuumImg.png'),
          technicalImg: require('../assets/imgs/highVacuumTechnical.png'),
          downloadImg: require('../assets/imgs/highVacuumDownload.png'),
          propertiesName: "highVacuumGateValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "vacuumGateValve",
          path: "VacuumValve7",
          isLast: true,

          pathImg: require('../assets/imgs/vacuum.png'),
          img: require('../assets/imgs/vacuumImg.png'),
          technicalImg: require('../assets/imgs/vacuumTechnical.png'),
          downloadImg: require('../assets/imgs/vacuumDownload.png'),
          propertiesName: "vacuumGateValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "combinedValve",
          path: "VacuumValve8",
          isLast: false,
          pathImg: require('../assets/imgs/combinedValve.png'),
          img: require('../assets/imgs/combinedValveImg.png'),
          technicalImg: require('../assets/imgs/combinedValveTechnical.png'),
          downloadImg: require('../assets/imgs/combinedValveDownload.png'),
          propertiesName: "combinedValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
      ],
      news: [],
      node: [],
      time: 3000,
      timer: 0,
      form: {},

      class1: {
        transform: ""
      },
      swiper: null,
      // 加了 loop 索引从1 开始
      activeIndex: 0,
      // 可以在这里设置轮播的选项
      settings: {
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      // CN  
      cnSwiperData: [
        {
          img: require("../assets//imgs/1-nei.png"),
          imgS: require("../assets//imgs/1-nei.png"),
          // img: require("../imgs/homeText.jpg"),
          imgP: require("../assets//imgs/banner1.png"),
          about: "关于佳晟",
          title: "佳晟公司简介",
          path: "about",
          content:
            "靖江佳晟真空技术有限公司创立于2018年，专注于半导体高性能真空阀门研发的创新型科技企业。在创立之初，佳晟真空与韩国第一真空阀门公司PRESYS深入合作......",
        },
        {
          img: require("../assets//imgs/2-nei.png"),
          imgS: require("../assets//imgs/2-nei.png"),
          // img: require("../imgs/homeText2.jpg"),
          imgP: require("../assets//imgs/banner2.png"),
          about: "产品服务",
          title: "佳晟.产品服务",
          path: "/valveRepairDndMaintenance",
          content:
            "以质量求发展，靠诚信行天下。 <br>助力客户价值提升是我们矢志不移的追求目标。",
          showStyle: true,
        },
        {
          img: require("../assets//imgs/3-nei.png"),
          imgS: require("../assets//imgs/3-nei.png"),
          // img: require("../imgs/homeTest3.jpg"),
          imgP: require("../assets//imgs/banner3.png"),
          about: "新闻资讯",
          title: "presys.佳晟参展CSEAC2022无锡展会",
          path: "News",
          content:
            "第十届（CSEAC 2022）中国半导体设备年会暨半导体设备与核心部件展示会 2022年10月27日，一年一度的半导体行业盛会，在无锡太湖国际博览中心拉开帷幕。",
        },
      ],
      // EN
      enSwiperData: [
        {
          img: require("../assets/imgs/1-nei-ying.png"),
          imgS: require("../assets/imgs/1-nei-ying.png"),
          imgP: require("../assets/imgs/banner1_en.png"),
          about: "About",
          title: "Company Introduction",
          path: "about",
          content:
            "Jingjiang Jiasheng Vacuum Technology Co., Ltd. was founded in 2018 and is an innovative technology and development of high-performance semiconductor vacuum valves. the first vacuum valve company in South Korea",
        },
        {
          img: require("../assets/imgs/2-nei-ying.png"),
          imgS: require("../assets/imgs/2-nei-ying.png"),
          imgP: require("../assets/imgs/banner2_en.png"),
          about: "Product Services",
          title: "Product Services",
          path: "/valveRepairDndMaintenance",
          content:
            "Strive development rely on integrity to the world. <br>Helping is our unwavering pursuit goal.",
          showStyle: true,
        },
        {
          img: require("../assets/imgs/3-nei-ying.png"),
          imgS: require("../assets/imgs/3-nei-ying.png"),
          imgP: require("../assets/imgs/banner3.png"),
          about: "News",
          title: "Presys. Jiasheng participated in CSEAC2022 Wuxi Exhibition",
          path: "News",
          content:
            "On October 27, 2022, the 10th (CSEAC 2022) China Semiconductor Equipment Annual Conference and Semiconductor",
        },
      ]
    };
  },
  computed: {
    dragBarClass() {
      let leftDesc = 0
      let desc = this.activeIndex < 0 ? this.activeIndex + 3 : this.activeIndex
      leftDesc = desc % 3 == 1 ? '33%' : desc % 3 == 2 ? '67%' : '0'
      return `left:${leftDesc}`
    }
  },
  mounted() {
    this.goTop();
    let _that = this;

    setTimeout(() => {
      let mySwiper = new Swiper(".mySwiper", {
        autoplay: true, //可选选项，自动滑动
        autoplayDelay: 3000,
        slidesPerGroup: 1,
        loop: true,
        effect: 'fade',
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        //   draggable: true,
        // },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      })
      mySwiper.on('slideChange', () => {
        // console.log('this.activeIndex', mySwiper.activeIndex)
        this.activeIndex = Number(mySwiper.activeIndex) - 1
      })
      /* banner-swiper */
      let swiper = new Swiper(".banner-swiper", {
        loop: true, // 循环模式选项
        effect: 'fade',
        //自动播放
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // 如果需要分页器
        // pagination: {
        //   el: ".swiper-pagination",
        //   type : 'progressbar',
        //   clickable: true,
        // },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
      // 监听滑块开始滑动事件
      // 监听滑动过程中的实时位置更新
      let that = this
      if (!this.isMobile()) {
        swiper.on('progress', function (progress) {
          if (progress >= 1) {
            _that.class1.transform = that.isMobile() ? "translate3d(10%, 0px, 0px)" : "translate3d(373px, 0px, 0px)"
          } else if (progress > 0.25) {
            _that.class1.transform = that.isMobile() ? "translate3d(120%, 0px, 0px)" : "translate3d(746px, 0px, 0px)"
          } else if (progress > 0.5) {
            _that.class1.transform = that.isMobile() ? "translate3d(73%, 0px, 0px)" : "translate3d(1119px, 0px, 0px)"
          } else if (progress == -0) {
            _that.class1.transform = that.isMobile() ? "translate3d(73%, 0px, 0px)" : "translate3d(1119px, 0px, 0px)"
          } else if (progress < 0.5) {
            _that.class1.transform = that.isMobile() ? "translate3d(120%, 0px, 0px)" : "translate3d(746px, 0px, 0px)"
          } else if (progress < 0.25) {
            _that.class1.transform = that.isMobile() ? "translate3d(10%, 0px, 0px)" : "translate3d(373px, 0px, 0px)"
          }
        });
      }
      _that.swiper = new Swiper(".pro-swiper", {
        loop: true,
        slidesPerView: this.isMobile() ? 1 : 4,
        loopedSlides: this.isMobile() ? 1 : 4,
        centeredSlides: this.isMobile(),
        // spaceBetween: 90, // 每个滑块之间的间距为30px
        // on: {
        //   // 原始事件绑定
        //   init: () => {
        //     // 如果需要在这里立即绑定一次事件
        //     // _that.bindNextSlideEvent();
        //   },
        // },
        speed: 2500,
        freeMode: true,
        //自动播放
        autoplay: {
          delay: 100,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          waitForTransition: true
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
    }, 400)
  },

  created() {
    this.searchHomeNews();
  },

  activated() {
    console.log('xxxx')
  },
  watch: {
    //该方法会在数据变化，触发执行
    //newValue新值，oldValue老值(一般不用)
    '$store.state.language'(newValue, oldValue) {
      console.log("变化前的值：", newValue, "变化后的值：", oldValue);
      this.searchHomeNews();
    },
  },
  methods: {
    search() {
      if (!this.form.keyword) {
        return;
      }
      homeSearch(this.form).then(res => {
        if (res && res.data && res.data.data) {
          this.goPageSwitch(res.data.data.title);
        }
      })
    },
    goPageSwitch(val) {
      switch (val) {
        // case "MGV/AGV":
        case "手动/自动真空闸阀":
          this.$router.push('VacuumValve1')
          break;
        case "蝶形控制阀":
          this.$router.push('VacuumValve2')
          break;
        case "高真空直通阀":
          this.$router.push('VacuumValve3')
          break;
        case "UHV角阀":
          this.$router.push('VacuumValve4')
          break;
        case "矩形阀":
          this.$router.push('VacuumValve5')
          break;
        case "高真空闸阀":
          this.$router.push('VacuumValve6')
          break;
        case "真空闸阀":
          this.$router.push('VacuumValve7')
          break;
        case "蝶阀和隔离阀":
          this.$router.push('VacuumValve8')
          break;
        case "TRANSFER DOOR VALVE SERIES V77":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[0] }
          })
          break;
        case "TRANSFER VALVE L-MOTION, SERIES V74":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[1] }
          })
          break;
        case "TRANSFER VALVE L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[2] }
          })
          break;
        case "NON-STANDARD DOUBLE OPENING L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[3] }
          })
          break;
        case "NON-STANDARD FOUR OPENING L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[4] }
          })
          break;
        case "ALL HEATING TRANSFER VALVE L-MOTION, SERIES V72":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[5] }
          })
          break;
        case "DOUBLE LAYER L-MOTION, SERIES V73":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[6] }
          })
          break;
        case "TRANSFER VALVE I-MOTION, SERIES V78":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[7] }
          })
          break;
        case "VACUUM GATE VALVE, SERIES V20":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[8] }
          })
          break;
        case "HV GATE VALVE, SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[9] }
          })
          break;
        case "UHV GATE VALVE/3-POSITION, SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[10] }
          })
          break;
        case "WITH HEAT JACKET,SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[11] }
          })
          break;
        case "HV PROTECTION GATE VALVE, SERIES V60":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[12] }
          })
          break;
        case "REMOTE PLASMA CONTROL VALVE , SERIES V41":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[13] }
          })
          break;
        case "LARGE TRANSFER VALVE/DOOR L-MOTION, SERIES V75":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[14] }
          })
          break;
        case "LARGE TRANSFER VALVE/INSERT T-MOTION, SERIES V76":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[15] }
          })
          break;
        case "Throttle Valve":
          this.$router.push("throttleValve")
          break;
        case "Throttle Valve Controller":
          this.$router.push("throttleValveController")
          break;
        case "Dual Throttle Valve":
          this.$router.push("dualThrottleValve")
          break;
        case "Multi Position Controller":
          this.$router.push("multiPositionController")
          break;
        case "MNE 密封圈O-RING":
          this.$router.push("MNE")
          break;
        case "UNISEM chiller温控装置":
          this.$router.push("UNISEMChiller")
          break;
      }
    },
    searchHomeNews() {
      let type = this.$store.state.language === '中文' ? "1" : "2";
      getHome({ "type": type }).then(res => {
        this.news = [];
        console.log(res.data.data, "res.data.data")
        if (res && res.data && res.data.data) {
          for (let i = 0; i < 3; i++) {
            if (res.data.data[i]) {
              this.news.push(res.data.data[i])
            }
          }
        } else {
          this.news = [];
        }
        console.log(this.news, "this.news")
      })
    },

    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    mouseover(e) {
      e.currentTarget.className = 'swiper-pro-btn-none';
    },
    mouseout(e) {
      e.currentTarget.className = "col12"
    },
    // bindNextSlideEvent() {
    //   // 为“下一幅”按钮绑定点击事件
    //   document.querySelector('#nextSlideBtn').addEventListener('click', () => {
    //     if (this.swiper) {
    //       this.swiper.slideNext();
    //     }
    //   });
    //   // 为“下一幅”按钮绑定点击事件
    //   document.querySelector('#prevSlideBtn').addEventListener('click', () => {
    //     if (this.swiper) {
    //       this.swiper.slidePrev();
    //     }
    //   });
    // },
    toPage(item) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      let params = [];
      this.list.forEach(t => {
        let data = Object.assign({}, t);
        if (t.path === item.path) {
          data.isShow = true;
          data.pathName = this.$t('i18n.headerMain.vacuumValve')
          data.lastPathName = this.$t('i18n.headerMainChildren.' + t.name)
        }
        params.push(data);
      });
      this.$router.push({
        name: item.path,
        params: { list: params }
      })
    },
    goNext() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
    goPrev() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
}
</script>

<style scoped>
.swiper-container-horizontal>.swiper-scrollbar {
  width: 100% !important;
  left: 0 !important;
}

.swiper-btn {
  margin-top: 10rem;
}

.container-fluid.--swiper {
  padding-left: 5rem;
  padding-right: 7rem;
}

.pc {
  display: block;
}

.mobile {
  display: none;
}

.main-content {
  z-index: 9999;
}

a {
  text-decoration: none;
  transition-property: all;
  transition-duration: .3s;
}

section {
  display: block;
}

/* 轮播图 */
/*#swiper {*/
/*  height: 1000px;*/
/*}*/

.swiper-container-horizontal>.swiper-scrollbar {
  height: 2px;
  /* 调整滚动条高度以容纳文字 */
  bottom: 40px;
  /* 与滑动内容保持一定距离 */
  background-color: white;
}

.swiper-scrollbar-drag {
  background-color: #990099;
  width: 33% !important;
  transition: .3s;
}

.scrollbar-caption {
  position: absolute;
  bottom: 0;
  /* 与滑动内容底部对齐 */
  transform: translateX(-50%);
  /* 水平居中 */
  width: fit-content;
  /* 自适应文字宽度 */
  color: white;
  padding: 5px;
  white-space: nowrap;
  pointer-events: none;
  /* 防止遮挡Swiper的滑动手势 */
  z-index: 9999999;
}

#swiper .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 82%;
}

#swiper .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 13.5%;
}

#swiper .swiper-button-next,
.swiper-button-prev {
  background-size: 18px 34px;
}

.pro-swiper-prev {
  background-image: url("../assets/imgs/proSwiperLeft.png");
  background-size: 16px 28px;
}

.pro-swiper-next {
  background-image: url("../assets/imgs/proSwiperRight.png");
  background-size: 16px 28px;
}

#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 70%;
  margin: 50px auto;
  /* height: 100%; */
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: -70px;
  left: 250px;
  z-index: 999999999;
  width: 38%;
  height: 100%;
  color: #fff;
  /*background: rgba(51, 51, 51, 0.534);*/
  text-align: left;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title-img {
  top: -160px;
}

#swiper .banner-swiper .swiper-slide-title>h3 {
  font-size: 20px;
  margin-top: 39%;
}

#swiper .banner-swiper .swiper-slide-title-img>h3 {
  font-size: 20px;
  margin-top: 44%;
  margin-left: 8%;
}

#swiper .banner-swiper .swiper-slide-title>h1 {
  font-size: 44px;
  margin-top: 4%;
}

#swiper .banner-swiper .swiper-slide-title-img>h1 {
  font-size: 44px;
  margin-top: 4%;
  margin-left: 8%;
}

#swiper .banner-swiper .swiper-slide-title>p {
  font-size: 24px;
  margin-top: 3%;
  line-height: 40px;
}

#swiper .banner-swiper .swiper-slide-title-img>p {
  font-size: 24px;
  margin-top: 3%;
  line-height: 40px;
  margin-left: 8%;
}

#swiper .banner-swiper .swiper-button-read {
  position: absolute;
  top: 58%;
  left: 250px;
  width: 290px;
  height: 85px;
  opacity: 0.6;
  color: #FFFFFF;
  font-size: 28px;
  background-color: #990099;
  border-radius: 10px;
}

#swiper .banner-swiper .swiper-button-read-s {
  left: 450px;
}

#swiper .banner-swiper .swiper-button-read .swiper-button-read-text {
  width: 50%;
  float: left;
  top: 25%;
  position: relative;
  text-align: center;
  justify-content: center;
  align-items: center;
}

#swiper .banner-swiper .swiper-button-read .swiper-button-read-img {
  width: 10%;
  float: right;
  position: relative;
  /*justify-content: center;*/
  /*align-items: center;*/
}

#swiper-pro {
  height: 100%;
}

#swiper-pro .swiper-container {
  height: 100% !important;
  width: auto !important;
  background: transparent !important;
}

#swiper-pro .pro-swiper .swiper-content {
  border: 1px solid lightgray;
  border-radius: 3%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 433px;
  width: 247px;
  background: white;
}

#swiper-pro .pro-swiper .swiper-content-select:hover {
  background-image: url("../assets/imgs/btnBackground.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.swiper-pro-btn {
  display: none;
}

#swiper-pro .pro-swiper .swiper-content-select:hover .swiper-pro-btn {
  border: 0;
  box-shadow: 0 .2rem .4rem 0 rgba(0, 0, 0, .05);
  background: #fff;
  font-weight: 300;
  font-size: 1.2rem;
  color: #66207F;
  letter-spacing: -.02rem;
  display: flex;
  justify-content: center;
  width: 80%;
  align-items: center;
  height: 4rem;
  position: relative;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.4rem;
  transition: all .2s ease-in-out;
  margin-left: 10%;
  margin-top: 2rem;
}


#swiper-pro .pro-swiper .swiper-content .swiper-pro-img {
  height: 276px;
  width: 210px;
}

#swiper-pro .pro-swiper .swiper-content .swiper-pro-bottom {
  text-align: center;
  /* 水平居中 */
  position: relative;
  height: 276px;
  width: 210px;
}

#swiper-pro .pro-swiper .swiper-content .swiper-pro-bottom .swiper-pro-text {
  color: #990099;
  width: 100%;
  position: absolute;
  top: 90%;
}

/*#swiper-pro .swiper-pro-btn-dis {*/
/*  display: none;*/
/*}*/
/*#swiper-pro .swiper-pro-btn-d .swiper-pro-btn {*/
/*  border: 0;*/
/*  box-shadow: 0 .2rem .4rem 0 rgba(0,0,0,.05);*/
/*  background: #fff;*/
/*  font-weight: 300;*/
/*  font-size: 1.2rem;*/
/*  color: #66207F;*/
/*  letter-spacing: -.02rem;*/
/*  display: flex;*/
/*  width: 80%;*/
/*  align-items: center;*/
/*  height: 4rem;*/
/*  position: relative;*/
/*  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;*/
/*  cursor: pointer;*/
/*  -webkit-appearance: none;*/
/*  -moz-appearance: none;*/
/*  appearance: none;*/
/*  border-radius: 0.4rem;*/
/*  transition: all .2s ease-in-out;*/
/*  margin-left: 10%;*/
/*}*/

#swiper-pro .swiper-pro-btn:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 4rem;
  top: 50%;
  margin-top: -0.5rem;
  background: #6C2188;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  transition: all .2s ease-in-out;
}

#swiper-pro .pro-swiper .swiper-content .swiper-pro-img img {
  display: block;
  /* 去除图片下方默认间距 */
  margin: 0 auto;
  /* 水平居中 */
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 垂直居中 */
}

.swiper .swiper-button-prev {
  left: 82%;
}

.swiper .swiper-button-next {
  right: 13.5%;
}

.swiper .swiper-button-prev,
.swiper .swiper-button-next {
  background-size: 18px 34px;
  transition: .3s;
}

.section {
  padding: 10rem 0;
  position: relative;
}

.section.--banner,
.section.--main-slider {
  padding: 0;
  max-width: 100vw;
  overflow-x: hidden;
}

.main-slider__arrows {
  position: absolute;
  z-index: 12;
  right: 5rem;
  top: 50%;
  margin-top: -1.5rem;
  display: flex;
}

.main-slider__arrow.--prev {
  -webkit-mask: url(../assets/imgs/arrow-slider-right.svg) no-repeat center;
  mask: url(../assets/imgs/arrow-slider-right.svg) no-repeat center;
  transform: rotate(180deg);
}

.main-slider__arrow {
  width: 3rem;
  height: 3rem;
  background: #fff;
  cursor: pointer;
  position: relative;
  transition: all .2s ease-in-out;
}

.main-slider__arrow.--next {
  -webkit-mask: url(../assets/imgs/arrow-slider-right.svg) no-repeat center;
  mask: url(../assets/imgs/arrow-slider-right.svg) no-repeat center;
  margin-left: 1rem;
}

.block-main-slider {
  display: block;
  width: 100vw;
  height: calc(100vh - 15rem);
  overflow: hidden;
  position: relative;
  background: #fff;
}

.block-main-slider__wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 9;
}

.commonBg {
  display: flex;
  justify-content: center;
  align-items: center;

}

.block-main-slider__slide-bg {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../assets/imgs/bg-1.png);
  background-size: cover;
  /* 保证背景图片覆盖元素并且不变形 */
  background-position: center;
  /* 将背景图片居中显示 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
}

.block-main-slider__slide-bgTwo {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../assets/imgs/homeSwiperImgTow.png);
  background-size: cover;
  /* 保证背景图片覆盖元素并且不变形 */
  background-position: center;
  /* 将背景图片居中显示 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
}

.block-main-slider__slide-bgThree {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../assets/imgs/homeSwiperImgThree.png);
  background-size: cover;
  /* 保证背景图片覆盖元素并且不变形 */
  background-position: bottom;
  /* 将背景图片居中显示 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
}

/*.block-main-slider__slide-bg:before {*/
/*  --opacity: 0;*/
/*  content: "";*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  background: linear-gradient(90deg,rgba(0,0,0,.8) 0,rgba(0,0,0,.7) 50%,rgba(0,0,0,.2));*/
/*  filter: alpha(opacity=var(--opacity));*/
/*  -moz-opacity: var(--opacity);*/
/*  -khtml-opacity: var(--opacity);*/
/*  opacity: var(--opacity);*/
/*}*/
.block-main-slider__slide-bg img {
  display: block;
  width: 100%;
  height: auto;
  /* -o-object-fit: cover; */
  /* object-fit: cover; */
  /* -o-object-position: 50% 50%; */
  /* object-position: 50% 50%; */
}

.commonBg img {
  width: 66%;
}

.block-main-slider__slide-content {
  position: relative;
  height: calc(100% - 14rem);
  z-index: 2;
}

.block-main-slider__h100 {
  height: 100%;
  z-index: 999999999;
}

.mySwiper {
  position: relative;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.block-main-slider__slide-text {
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 37%;
  position: relative;
  height: 47rem;
  transform: translateY(-50%);
}

.banner__type {
  font-weight: 400;
  color: #FFFFFF;
  font-size: 2rem;
  line-height: 1.7rem;
  margin-bottom: 1rem;
}

.banner__titles {
  position: relative;
}

.banner__title {
  font-weight: 300;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 2rem;
  padding-right: 2rem;
}

.banner__subtitle {
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: -.015rem;
  line-height: 3rem;
  padding-right: 3rem;

  color: #FFFFFF;
}

/*.banner__button-wrapper {*/
/*  margin-top: auto;*/
/*}*/
.btn.--primary {
  padding: 0 6.5rem 0 3rem;
  /* background: #bb00bb; */
  background-color: rgb(95, 49, 126);
  opacity: 0.8;
  font-size: 1.8rem;
  color: #fff;
  letter-spacing: -.02rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .05)
}

.btn.--primary:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 3rem;
  top: 50%;
  margin-top: -.5rem;
  background: #fff;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  transition: all .2s ease-in-out;
}

.btn {
  display: flex;
  width: 100%;
  align-items: center;
  height: 6rem;
  position: relative;
  border: 0;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.4rem;
  transition: all .2s ease-in-out;
}

.swiper-container {
  display: block;
  width: 100vw;
  height: calc(100vh - 15rem) !important;
  overflow: hidden;
  position: relative;
  background: #fff;
}

.scroll-down {
  cursor: pointer;
  width: auto;
  height: 3rem;
  background: black;
  -webkit-mask: url(../assets/imgs/arrow.png) no-repeat center;
  mask: url(../assets/imgs/arrow.png) no-repeat center;
  -webkit-animation: float 3s ease-in-out infinite;
  animation: float 3s ease-in-out infinite;
  transition: all .2s ease-in-out;
}


.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  max-width: 123rem;
  padding-right: 30px;
  padding-left: 30px;
}

.block-main-slider__h100 {
  height: 100%;
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.auto-mr {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.form-input,
input[type=email],
input[type=text] {
  width: 100%;
  height: 6rem;
  padding: 0 2.5rem;
  /* font-size: 1.8rem; */
  font-size: 1.3rem;
  color: #000;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition-property: all;
  transition-duration: .3s;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

.header__content-a {

  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #7f7f7f;
  display: block;
}


.block-main-slider__wrapper .slick-list,
.block-main-slider__wrapper .slick-track {
  height: 100%;
}

.block-news {
  /* padding-top: 4rem; */
  margin-top: -5.5rem;
}

.block-news__header {
  display: flex;
}

.label.--news {
  display: flex;
  align-items: end;
}

.label-text {
  font-weight: bold;
  /* font-size: 24px; */
  font-size: 16px;
  color: #231815;
  font-weight: 700;
}

.label-text2 {
  font-weight: 300;
  /* font-size: 20px; */
  font-size: 18px;
  color: #231815;
}

.label {
  font-weight: 600;
  /* font-size: 1.4rem; */
  font-size: 1.6rem;
  color: #000;
  letter-spacing: .035rem;
  line-height: 1.7rem;
  text-transform: uppercase;
}

.product-filter {
  display: flex;
  width: 100%;
  border: 0;
  padding: 0;
  border-radius: 0.4rem;
  margin-top: 40px;
}

.product-filter__search {
  width: 100%;
  position: relative;
  flex-grow: 1;
}

.product-filter .product-filter__search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.product-filter__search-input {
  padding: 0 3rem;
  margin: 0;
  border: 0.1rem solid #e6e6e6;
  height: 7rem !important;
  width: 100%;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  font-size: 1.8rem;
  color: #000;
  letter-spacing: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition: all .2s ease-in-out;
  border-radius: 0.4rem;
}

.product-filter__search-input:focus {
  background: #fafafa;
}

.product-filter__search-icon {
  position: absolute;
  z-index: 3;
  width: 7rem;
  height: 7rem;
  background: #990099;
  padding: 0;
  right: 0;
  top: 50%;
  margin: -3.5rem 0 0;
  cursor: pointer;
  -webkit-mask: url(../assets/imgs/searchImg.png) no-repeat center;
  mask: url(../assets/imgs/searchImg.png) no-repeat center;
  transition: all .2s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.product-filter__filter-btn {
  height: 7rem;
  padding: 0 3rem;
  margin: 0;
  right: 0;
  top: 50%;
  cursor: pointer;
  border-radius: 0.4rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-left: 0;
  font-weight: 600;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  text-transform: uppercase;
  font-size: 1.4rem;
  color: #000;
  letter-spacing: .035rem;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  transition-property: background;
  transition-duration: .3s;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .05)
}

.product-filter__filter-btn:before {
  content: "";
  width: 2rem;
  height: 2rem;
  background: url(../assets/imgs/buttonImg.png) no-repeat 50%;
}

.label.--news:before {
  content: "";
  width: 5rem;
  height: 4.8rem;
  display: block;
  margin-right: 2rem;
  background: url(../assets/imgs/file.png) no-repeat 50%;
}

.text-link.--small {
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.text-link {
  font-size: 1.8rem;
  color: #6C2188;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding-right: 2rem;
  position: relative;
  transition: all .2s ease-in-out;
}

.text-link:hover {
  color: #000;
}

.text-link:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 0.5rem;
  top: 76%;
  /* margin-top: -0.5rem; */
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}

.text-link:hover:after {
  right: 0rem;
}

.block-news__article {
  display: block;
  border-bottom: 0.1rem solid #e6e6e6;
  padding: 3rem 3rem 3rem 0;
  transition: all .4s ease-in-out;
}

.block-news__article:hover {
  border-bottom: 0.1rem solid #990099;
}

.block-news__article:hover span {
  color: #CCC;
}

.block-news__article span {
  font-weight: 500;
  /* font-size: 1.4rem; */
  font-size: 1.3rem;
  line-height: 1.7rem;
  /* color: #ccc; */
  color: #000;
  letter-spacing: .035rem;
  display: block;
  margin-bottom: 1rem;
  text-transform: uppercase;
  transition: all .2s ease-in-out;
}

.block-news__article h4 {
  font-weight: 600;
  font-size: 2rem;
  color: #000;
  letter-spacing: -.02rem;
  line-height: 2.6rem;
  margin: 0 0 1rem;
  padding: 0;
}

.block-news__article p {
  /* font-size: 2rem; */
  font-size: 1.6rem;
  font-weight: 500;
  color: #4c4c4c;
  letter-spacing: -.02rem;
  line-height: 3rem;
  transition: all .2s ease-in-out;
}

.block-downloads {
  padding: 4rem 5rem 5rem;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
}

.label.--downloads {
  display: flex;
  /* align-items: center; */
  align-items: end;
}

.label.--downloads:before {
  content: "";
  width: 4.8rem;
  height: 4.8rem;
  display: block;
  margin-right: 2rem;
  background: url(../assets/imgs/downloads.png) no-repeat 50%;
}

.block-download__text {
  font-weight: 300;
  /* font-size: 3rem; */
  font-size: 2.5rem;
  color: #000;
  letter-spacing: -.015rem;
  line-height: 4rem;
  margin-top: 3rem;
}

.ul-link {
  margin-bottom: 2rem;
}

.text-link.--big {
  /* font-size: 2rem; */
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  padding-right: 3rem;
}

.text-link.--big:after {
  right: 0.5rem;
  width: 0.8rem;
  height: 1.4rem;
  margin-top: -0.7rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}

.text-link.--big:hover:after {
  right: 0rem;
}

.btn.--secondary.--ongray {
  /*border: 0;*/
  /*box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);*/
}

.btn.--secondary {
  padding: 0 6.5rem 0 3rem;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  font-weight: 400;
  /* font-size: 1.8rem; */
  font-size: 1.3rem;
  color: #6C2188;
  letter-spacing: -.02rem;
}

.btn.--secondary:hover {
  background: #6C2188;
  color: #FFF;
}

.btn.--secondary:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 3rem;
  top: 50%;
  margin-top: -0.5rem;
  background: #6C2188;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  transition: all .2s ease-in-out;
}

.block-case-studies__header {
  display: flex;
  margin-bottom: 3rem;
}

.label.--case-studies {
  display: flex;
  align-items: end;
}

.label.--case-studies:before {
  content: "";
  width: 4.8rem;
  height: 6rem;
  display: block;
  margin-right: 2rem;
  background: url(../assets/imgs/core-products.png) no-repeat 50%;
}

.text-link.--small {
  font-size: 1.6rem;
  display: flex;
  align-items: end;
}

.label.--b-company {
  display: flex;
  align-items: end;
}

.label.--b-company:before {
  content: "";
  width: 6.8rem;
  height: 6rem;
  display: block;
  margin-right: 2rem;
  background: url(../assets/imgs/company.png) no-repeat 50%;
}

.block-about__text {
  font-weight: 300;
  /* font-size: 2rem; */
  font-size: 1.6rem;
  color: #000;
  letter-spacing: -.015rem;
  line-height: 4rem;
  padding: 0;
  margin: 2rem 0 0;
}

.block-main-slider__slide-text {
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 37%;
  position: relative;
  height: 47rem;
  transform: translateY(-50%);
}

.block-main-slider__slide {
  width: 100%;
  height: 100%;
  position: relative;
  float: left;
}

@media (min-width: 1024px) {
  .specialClass1 {
    position: relative;
    top: 10px;
  }

  .specialClass3 {
    position: absolute !important;
    left: 8%;
    width: 20% !important;
  }

  .swiper .swiper-button-prev:hover {
    left: 81.8%;
  }

  .swiper .swiper-button-next:hover {
    right: 13.3%;
  }
}

/*@media (min-width: 1024px) {*/
/*  .d-md-flex {*/
/*    display: flex !important;*/
/*  }*/
/*  .text-md-center {*/
/*    text-align: center !important;*/
/*  }*/
/*  .mt-md-0, .my-md-0 {*/
/*    margin-top: 0 !important;*/
/*  }*/
/*  .col-md-8 {*/
/*    flex: 0 0 66.6666666667%;*/
/*    max-width: 66.6666666667%;*/
/*  }*/
/*  .order-md-1 {*/
/*    order: 1;*/
/*  }*/
/*  .col-md-5 {*/
/*    padding-right: 5rem !important;*/
/*  }*/
/*  .col-md-5 {*/
/*    flex: 0 0 41.6666666667%;*/
/*    max-width: 41.6666666667%;*/
/*  }*/
/*  .w-md-100 {*/
/*    width: 100% !important;*/
/*  }*/
/*  .w-auto {*/
/*    width: auto !important;*/
/*  }*/
/*  .mt-md-4, .my-md-4 {*/
/*    margin-top: 4rem !important;*/
/*  }*/
/*  .mb-md-3, .my-md-3 {*/
/*    margin-bottom: 3rem !important;*/
/*  }*/
/*  .d-md-block {*/
/*    display: block !important;*/
/*  }*/
/*  .d-md-flex {*/
/*    display: flex !important;*/
/*  }*/
/*  .col-md-6 {*/
/*    flex: 0 0 50%;*/
/*    max-width: 50%;*/
/*    padding-right: 0px;*/
/*    padding-left: 0px;*/
/*  }*/
/*  .pr-md-2, .px-md-2 {*/
/*    padding-right: 2rem !important;*/
/*  }*/
/*  .pr-0, .px-0 {*/
/*    padding-right: 0 !important;*/
/*  }*/
/*  .col-md-6 {*/
/*    flex: 0 0 50%;*/
/*    max-width: 50%;*/
/*  }*/
/*  .pl-md-2, .px-md-2 {*/
/*    padding-left: 2rem !important;*/
/*  }*/
/*  .mt-md-12, .my-md-12 {*/
/*    margin-top: 12rem !important;*/
/*  }*/
/*  .col-md-3 {*/
/*    flex: 0 0 25%;*/
/*    max-width: 25%;*/
/*  }*/
/*}*/

.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-se,
.col-se-1,
.col-se-2,
.col-se-3,
.col-se-4,
.col-se-5,
.col-se-6,
.col-se-7,
.col-se-8,
.col-se-9,
.col-se-10,
.col-se-11,
.col-se-12,
.col-se-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xsm,
.col-xsm-1,
.col-xsm-2,
.col-xsm-3,
.col-xsm-4,
.col-xsm-5,
.col-xsm-6,
.col-xsm-7,
.col-xsm-8,
.col-xsm-9,
.col-xsm-10,
.col-xsm-11,
.col-xsm-12,
.col-xsm-auto,
.col-xxl,
.col-xxl-1,
.col-xxl-2,
.col-xxl-3,
.col-xxl-4,
.col-xxl-5,
.col-xxl-6,
.col-xxl-7,
.col-xxl-8,
.col-xxl-9,
.col-xxl-10,
.col-xxl-11,
.col-xxl-12,
.col-xxl-auto,
.col-xxsm,
.col-xxsm-1,
.col-xxsm-2,
.col-xxsm-3,
.col-xxsm-4,
.col-xxsm-5,
.col-xxsm-6,
.col-xxsm-7,
.col-xxsm-8,
.col-xxsm-9,
.col-xxsm-10,
.col-xxsm-11,
.col-xxsm-12,
.col-xxsm-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  max-width: 123rem;
  padding-right: 30px;
  padding-left: 30px;
}

.block-main-slider__h100 {
  height: 100%;
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.auto-mr {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.mb-2,
.my-2 {
  margin-bottom: 2rem !important;
}

.form-input,
input[type=email],
input[type=text] {
  width: 100%;
  height: 6rem;
  padding: 0 2.5rem;
  /* font-size: 1.8rem; */
  font-size: 1.3rem;
  color: #000;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition-property: all;
  transition-duration: .3s;
}



.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

.header__content-a {

  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #7f7f7f;
  display: block;
}

.mt-6,
.my-6 {
  margin-top: 6rem !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.mt-3,
.my-3 {
  margin-top: 3rem !important;
}

.mt-4,
.my-4 {
  margin-top: 4rem !important;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mt-6,
.my-6 {
  margin-top: 6rem !important;
}

.pr-2,
.px-2 {
  padding-right: 2rem !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.mb-2,
.my-2 {
  margin-bottom: 2rem !important;
}

.mb-3,
.my-3 {}

.block-main-slider__wrapper .slick-list,
.block-main-slider__wrapper .slick-track {
  height: 100%;
}

.outSwiperBox {
  position: relative;
  padding: 0 50px;
}

.inSwiperBox {
  height: 100%;
  position: initial;
}

.container-fluid.--swiper {
  max-width: 140rem;
}

.banner-btn {
  display: flex
}

.text1 {
  left: 30%
}

.text2 {
  left: 50%
}

.text3 {
  left: 70%
}

@media (min-width: 1023.9px) {}

@media (min-width: 1024px) {

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .text-md-center {
    text-align: center !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .order-md-1 {
    order: 1;
  }

  .col-md-5 {
    padding-right: 5rem !important;
  }

  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .w-md-100 {
    width: 100% !important;
  }

  .w-auto {
    width: auto !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 4rem !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 3rem !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 2rem !important;
  }

  .pr-0,
  .px-0 {
    padding-right: 0 !important;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 2rem !important;
  }

  .mt-md-12,
  .my-md-12 {
    margin-top: 12rem !important;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

/* 媒体查询，针对最大宽度为768像素的设备 */
@media (max-width: 768px) {
  .section {
    padding-top: 4rem;
  }

  .mt-auto {
    margin-top: 0 !important;
  }

  .block-main-slider__h100.--mobile-auto {
    /* height: 40rem; */
    height: 20rem;
  }

  .block-main-slider__slide-text {
    /* justify-content: center; */
    margin-top: 0;
    height: 100%;
    position: relative;
    z-index: 3;
    height: 42rem;
    transform: translateY(0);
  }

  .banner__type {
    margin-bottom: 1rem;
  }

  .banner__title {
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -.05rem;
    margin-bottom: 1.5rem;
    padding-right: 0;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .banner__subtitle {
    /* font-size: 2rem; */
    line-height: 2.8rem;
    letter-spacing: -.02rem;
    font-size: 1.5rem;
    /* display: -webkit-box; */
    /* -webkit-line-clamp: 5; */
    /* -webkit-box-orient: vertical; */
    /* overflow: hidden; */
  }

  .outSwiperBox {
    padding: 0 70px;
  }

  .pro-swiper-next.--pro {
    top: 50%;
  }

  .pro-swiper-prev.--pro {
    top: 50%;
  }

  .banner-btn {
    display: block;
    font-size: 12px;
  }

  .text1,
  .text2,
  .text3 {
    position: absolute;
    transform: translateX(0%);
    text-align: center;
    font-size: 11px;
  }

  .text1 {
    left: 0;
    width: 23%;
  }

  .text2 {
    left: 23%;
    width: 23%;
  }

  .text3 {
    left: 46%;
    width: 54%;
  }

  /* .pc{
    display: none;
  } */
  .mobile {
    display: block;
  }

  #swiper .banner-swiper .swiper-slide img {
    margin: 0px auto;
    /* height: 100%; */
  }

  #swiper .banner-swiper .swiper-slide-title {
    left: 20px;
    width: calc(100% - 40px);
  }

  #swiper .banner-swiper .swiper-button-read {
    left: 20px;
    top: 50%;
  }

  #swiper .swiper-button-next {
    right: 13.5px;
  }

  .swiper-button-next,
  .swiper-button-prev {
    top: 40px;
  }

  #swiper .banner-swiper .swiper-slide-title-img1 {
    overflow: hidden;
  }

  #swiper .banner-swiper .swiper-slide-title-img1>h3 {
    margin-top: 87%;
    position: relative;
    left: 50px;
    width: calc(100% - 50px);
  }

  #swiper .banner-swiper .swiper-slide-title-img1>h1 {
    position: relative;
    left: 35px;
    font-size: 20px;
    width: calc(100% - 50px);
  }

  #swiper .banner-swiper .swiper-slide-title-img1>p {
    position: relative;
    left: 35px;
    font-size: 14px;
    width: calc(100% - 50px);

  }

  .swiper .swiper-button-prev,
  .swiper .swiper-button-next {}

  .swiper .swiper-button-prev {
    left: 82%;
  }

  .swiper .swiper-button-next {
    right: 13.5px
  }
}


@media (max-width: 430px) {
  .outSwiperBox {
    padding: 0 30px;
  }
}

@media (max-width: 375px) {
  .outSwiperBox {
    padding: 0 50px;
  }


}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue